import React__default from 'react';

const useCachedProp = ({ prop, shouldUpdate }) => {
    const cachedProp = React__default.useRef(null);
    React__default.useEffect(() => {
        if (shouldUpdate) {
            cachedProp.current = prop;
        }
    }, [shouldUpdate, prop]);
    return !shouldUpdate && cachedProp.current !== null ? cachedProp.current : prop;
};

export { useCachedProp };
